var map = {
	"./goldcoin/pop-award-icon-0.png": 17116,
	"./memetown/pop-award-icon-0.png": 49847,
	"./reflection/pop-award-icon-0.png": 63218,
	"./tapcoin/pop-award-icon-0.png": 79986
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60485;